import type { DirectoryRelease } from './aggregate-releases'
import {
  packProduct,
  unpackProduct,
  type PackedDirectoryProduct,
  type ProductPacking,
  type ProductUnpacking,
} from './packed-product'

type FacetKey = 'classification' | 'tags' | 'channels' | 'accessories' | 'hardware' | 'software' | 'loss' | 'style'
type PackedFacets = [
  classification: number,
  tags: number,
  channels: number,
  accessories: number,
  hardware: number,
  software: number,
  loss: number,
  style: number,
]

export type PackedDirectoryRelease = Omit<
  DirectoryRelease,
  FacetKey | 'products' | 'offer' | 'image' | 'quietAudioUrl'
> & {
  facets: PackedFacets
  products: PackedDirectoryProduct[]
  offer: number
  image: number
  quietAudioUrl: number
}

export const packRelease = (release: DirectoryRelease, pack: ProductPacking): PackedDirectoryRelease => {
  const { classification, tags, channels, accessories, hardware, software, loss, style, ...identity } = release
  return {
    ...identity,
    facets: [
      pack.list(classification),
      pack.list(tags),
      pack.list(channels),
      pack.list(accessories),
      pack.list(hardware),
      pack.list(software),
      pack.list(loss),
      pack.list(style),
    ],
    image: pack.image(release.image),
    quietAudioUrl: pack.audio(release.quietAudioUrl),
    offer: pack.offer(release.offer),
    products: release.products.map((product) => packProduct(product, pack)),
  }
}

export const unpackRelease = (release: PackedDirectoryRelease, unpack: ProductUnpacking): DirectoryRelease => {
  const { facets, ...identity } = release
  return {
    ...identity,
    classification: unpack.list(facets[0]),
    tags: unpack.list(facets[1]),
    channels: unpack.list(facets[2]),
    accessories: unpack.list(facets[3]),
    hardware: unpack.list(facets[4]),
    software: unpack.list(facets[5]),
    loss: unpack.list(facets[6]),
    style: unpack.list(facets[7]),
    image: unpack.image(release.image),
    quietAudioUrl: unpack.audio(release.quietAudioUrl),
    offer: unpack.offer(release.offer),
    products: release.products.map((product) => unpackProduct(product, unpack)),
  }
}
